"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "What types of construction equipment do you lease?",
  answer: "AT & E brokers a comprehensive range of construction equipment including excavators, loaders, bulldozers, cranes, forklifts, scaffolding, and power tools. We partner with Sunbelt Rentals and United Rentals to provide access to their extensive inventory."
}, {
  id: 2,
  question: "How does the delivery and pickup process work?",
  answer: "Our team coordinates all logistics for equipment delivery and pickup directly to your job site in Ripon and surrounding areas. We schedule delivery times that align with your project timeline and handle all necessary paperwork, ensuring a seamless experience from start to finish."
}, {
  id: 3,
  question: "What are your rental terms and pricing?",
  answer: "Rental terms are flexible and tailored to your project needs, whether daily, weekly, or monthly. Pricing varies based on equipment type and rental duration. Contact us at info@atandellc.com for a customized quote that fits your budget and schedule."
}, {
  id: 4,
  question: "Do you provide maintenance support during the rental period?",
  answer: "Yes, all equipment is maintained and inspected by our partner providers before delivery. If any issues arise during your rental period, our responsive service team coordinates immediate support or equipment replacement to keep your project on track."
}, {
  id: 5,
  question: "What areas do you serve?",
  answer: "We primarily serve the Ripon, California area and surrounding construction zones. Our delivery network extends throughout the Central Valley region. Contact us to confirm service availability for your specific location."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="faq" className="bg-background py-16 px-4 sm:px-6 lg:px-8" ref={ref}>
      <div className="mx-auto max-w-3xl">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="text-foreground mb-4 font-display text-3xl font-bold sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg">
            Find answers to common questions about our equipment leasing and delivery services.
          </p>
        </div>

        <Accordion type="single" collapsible className={`space-y-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="bg-background hover:bg-muted/30 rounded-lg border border-border px-6 transition-colors duration-[var(--duration-fast)]">
              <AccordionTrigger className="text-foreground text-left text-base font-semibold hover:no-underline sm:text-lg">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm leading-relaxed sm:text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}